













































import { Vue, Component, Prop } from 'vue-property-decorator';
import WebhookListItem from './webhook-list-item.entity';

@Component

export default class ServiceHookList extends Vue {
  @Prop({
    type: Array,
    default: false,
  })
  private webhooks!: WebhookListItem[];

  @Prop({
    type: Boolean,
    default: false,
  })
  private loading!: boolean;

  private headers: any[] = [
    { value: 'webhookType.name', text: 'Evento' },
    { value: 'webhookType.description', text: 'Descrição' },
    { value: 'webhookType.methodType', text: 'Ação', sortable: false },
    { value: 'url', text: 'Para o host' },
    { value: 'createdBy', text: 'Criado por' },
    {
      value: 'actions',
      text: 'Ações',
      align: 'center',
      sortable: false,
    },
  ];

  private deleteWebhook(webhookId: string): void {
    this.$emit('deleteWebhook', webhookId);
  }

  private editWebhook(webhook: WebhookListItem): void {
    this.$emit('editWebhook', webhook);
  }
}

